import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ConsumerLayout from '../consumer-layout/ConsumerLayout';
import Header from '../../header/Header';
import { ACTIV8_TABS, PROJECT_TYPES, PROJECT_VARIANTS } from '../../constants';
import { ProjectProvider } from '../../context/ProjectContext';
import CommonTabs from '../../components/common-tabs/CommonTabs';
import useActiv8Tabs from '../../activ8/hooks/useActiv8Filters';
import { changeActiv8Tab, resetParams } from '../../redux/activ8/activ8Reducer';
import CommonTabPanel from '../../components/common-tabs/CommonTabPanel';
import Find from './components/find/Find';
import { clearCaches } from '../../service/mediaCache';

import scss from './Activ8.module.scss';

function Activ8() {
  const dispatch = useDispatch();
  const TABS = useActiv8Tabs();

  const activ8Tab = useSelector((state) => state.activ8.activ8Tab);

  const handleChangeTabs = (_, newTab) => {
    dispatch(changeActiv8Tab(newTab));
  };

  useEffect(() => {
    return () => {
      dispatch(resetParams());
      clearCaches();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConsumerLayout Header={Header()}>
      <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.ACTIV8}>
        <CommonTabs tabs={TABS} value={activ8Tab} onChange={handleChangeTabs} className={scss.tabs} isFullWidth />

        <CommonTabPanel value={activ8Tab} index={ACTIV8_TABS.IDEAS} className={scss.tabPanel}>
          <Find />
        </CommonTabPanel>

        <CommonTabPanel value={activ8Tab} index={ACTIV8_TABS.IMAGES} className={scss.tabPanel}>
          STUDIO
        </CommonTabPanel>

        <CommonTabPanel value={activ8Tab} index={ACTIV8_TABS.RECREATE} className={scss.tabPanel}>
          STORY
        </CommonTabPanel>
      </ProjectProvider>
    </ConsumerLayout>
  );
}

export default Activ8;
